import { Action } from 'redux';
import { EffectiveDateStateStructure } from '../interfaces/effective-date.state-structure.interface';

import moment from 'moment';
import * as DateFunctions from 'src/app/shared/services/date.functions';

export const EFFECTIVE_DATE_STATE_NAME = 'EffectiveDate';

/** INITIAL STATE */
// TODO: DATEOFFSET: Run this to update whenever 'NOW' gets udpated in DateService for Date Offset
const INITIAL_STATE: EffectiveDateStateStructure = {
  effectiveDate: DateFunctions.getFirstOfNextMonth().format('YYYY-MM-DD'),
  effectiveDateYear: DateFunctions.getFirstOfNextMonth().year().toString(),
  dirtyEffectiveDate: false
};

/** ACTION TYPES */
const STORE_EFFECTIVE_DATE_STATE = 'STORE_EFFECTIVE_DATE_STATE';
const SET_EFFECTIVE_DATE = 'SET_EFFECTIVE_DATE';
const SET_DIRTY_EFFECTIVE_DATE = 'SET_DIRTY_EFFECTIVE_DATE';
const RESET_DIRTY_EFFECTIVE_DATE = 'RESET_DIRTY_EFFECTIVE_DATE';
const CLEAR_EFFECTIVE_DATE = 'CLEAR_EFFECTIVE_DATE';

/** ACTION INTERFACE */
export class EffectiveDateAction implements Action {
  type: string;
  state?: EffectiveDateStateStructure;
  effectiveDate?: string;
  dirtyEffectiveDate?: boolean;
}

/** EFFECTIVE DATE ACTIONS */
export function setEffectiveDate(effectiveDate: string): EffectiveDateAction {
  return { type: SET_EFFECTIVE_DATE, effectiveDate };
}
export function setDirtyEffectiveDate(): EffectiveDateAction {
  return { type: SET_DIRTY_EFFECTIVE_DATE };
}

export function resetDirtyEffectiveDate(): EffectiveDateAction {
  return { type: RESET_DIRTY_EFFECTIVE_DATE };
}

export function clearEffectiveDateAppState(): EffectiveDateAction {
  return { type: CLEAR_EFFECTIVE_DATE }
}

export function storeEffectiveDateState(state: EffectiveDateStateStructure): EffectiveDateAction {
  return { type: STORE_EFFECTIVE_DATE_STATE, state }
}

/** REDUCER */
export function EffectiveDate(state: EffectiveDateStateStructure = INITIAL_STATE, action: EffectiveDateAction) {

  const copiedState: EffectiveDateStateStructure = JSON.parse(JSON.stringify(Object.assign({}, state)));

  switch (action.type) {
    /** FULL STATE REPLACEMENT */
    case STORE_EFFECTIVE_DATE_STATE:
      return Object.assign({}, state, action.state);
    case SET_EFFECTIVE_DATE:
      const effectiveDate = action.effectiveDate;
      const effectiveDateYear: string = moment(effectiveDate).year().toString();
      
      // Create a cookie to be consumed by AEM servlets only.
      const cookieName = 'sxe_effectiveDate-plan_year';
      const domain = window.location.hostname;
      document.cookie = `${cookieName}=${effectiveDateYear};Domain=${domain};path=/;secure`;

      copiedState.effectiveDate = effectiveDate;
      copiedState.effectiveDateYear = effectiveDateYear;
      return Object.assign({}, state, copiedState);
    case SET_DIRTY_EFFECTIVE_DATE:
      copiedState.dirtyEffectiveDate = true;
      return Object.assign({}, state, copiedState);
    case RESET_DIRTY_EFFECTIVE_DATE:
      copiedState.dirtyEffectiveDate = false;
      return Object.assign({}, state, copiedState);
    case CLEAR_EFFECTIVE_DATE: 
      if(copiedState.effectiveDate){
        copiedState.effectiveDate = null;
        copiedState.dirtyEffectiveDate = false
        return Object.assign({}, state, copiedState);
      }
      return copiedState;
    default:
      return state;
  }
}
